import { assertProfileAvailable } from '../../Common/profileAvailability';
import { Autocomplete, TextField } from '@mui/material';
import { get, ref, remove, set, update } from 'firebase/database';
import { deleteDoc, doc, getDoc, setDoc } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { database, firestore } from '../../Common/Firebase';

import '../ModalMaterial/style.scss';
import { throwErrorRollbar } from '../../index';
import { departmentsArr } from '../CreateStudentModal/utils';

const EditStudentModal = ({ open, setOpen, submit, student, fetchStudentView }) => {
  const { t } = useTranslation();
  const [lastName, setLastName] = useState(student ? student.lastName : '');
  const [firstName, setFirstName] = useState('');
  const [patronymic, setPatronymic] = useState('');
  const [age, setAge] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState(student ? student.email : '');
  const [branch, setBranch] = useState(student ? student.branch : '');
  const [classStudent, setClassStudent] = useState('');
  const [lastNameDirty, setLastNameDirty] = useState(false);
  const [lastNameError, setLastNameError] = useState('');
  const [firstNameDirty, setFirstNameDirty] = useState(false);
  const [firstNameError, setFirstNameError] = useState('');
  const [patronymicDirty, setPatronymicDirty] = useState(false);
  const [patronymicError, setPatronymicError] = useState('');
  const [emailDirty, setEmailDirty] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [ageDirty, setAgeDirty] = useState(false);
  const [ageError, setAgeError] = useState('');
  const [classStudentDirty, setClassStudentDirty] = useState(false);
  const [classStudentError, setClassStudentError] = useState('');
  const [cityDirty, setCityDirty] = useState(false);
  const [cityError, setCityError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);

  const navigate = useNavigate();

  const lastNameHandler = e => {
    const value = e.target.value;
    setLastNameDirty(true);

    if (value === undefined || value.trim() === '') {
      setLastNameError(t('field is required'));
    } else if (!/^(?!.*['`]{2})(?!.*['`].*['`])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ']*)$/.test(value.trim())) {
      setLastNameError(t('Last name must start with a capital letter and contain only letters'));
    } else {
      setLastNameError('');
    }
  };

  const firstNameHandler = e => {
    const value = e.target.value;
    setFirstNameDirty(true);

    if (value === undefined || value.trim() === '') {
      setFirstNameError(t(''));
    } else if (!/^(?!.*['`]{2})(?!.*['`].*['`])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ']*)$/.test(value.trim())) {
      setFirstNameError(t('First name must start with a capital letter and contain only letters'));
    } else {
      setFirstNameError('');
    }
  };

  const patronymicHandler = e => {
    const value = e.target.value;
    setPatronymicDirty(true);

    if (value === undefined || value.trim() === '') {
      setPatronymicError(t(''));
    } else if (!/^(?!.*['`]{2})(?!.*['`].*['`])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ']*)$/.test(value.trim())) {
      setPatronymicError(t('Patronymic must start with a capital letter and contain only letters'));
    } else {
      setPatronymicError('');
    }
  };

  const emailHandler = e => {
    const value = e.target.value;
    const re =
      /^(([a-z0-9]{1}[-0-9a-z\.]{1,}[0-9a-z]{1})|([0-9]{1}[-0-9a-z\.]{1,}[0-9]{1}))@([-0-9a-z]{1,}\.){1,2}[-a-z]{2,}$/u;

    setEmail(value);

    if (value === undefined || value.trim() === '') {
      setEmailError(t('field is required'));
    } else if (!re.test(String(value).toLocaleLowerCase())) {
      setEmailError(t('Wrong email address format'));
    } else {
      setEmailError('');
    }
  };

  const ageHandler = e => {
    const value = e.target.value;
    setAgeDirty(true);

    if (value.trim() === '') {
      setAgeError('');
    } else if (!/^\d+$/.test(value.trim())) {
      setAgeError(t('Age can only be a number'));
    } else {
      const numberValue = parseInt(value, 10);
      if (numberValue < 1 || numberValue > 100) {
        setAgeError(t('Age must be a number from 1 to 100'));
      } else {
        setAgeError('');
      }
    }
  };

  const classStudentHandler = e => {
    const value = e.target.value;
    setClassStudentDirty(true);

    if (value.trim() === '') {
      setClassStudentError('');
    } else if (!/^\d+$/.test(value.trim())) {
      setClassStudentError(t('Class can only be a number'));
    } else {
      const numberValue = parseInt(value, 10);
      if (numberValue < 1 || numberValue > 11) {
        setClassStudentError(t('Class must be a number from 1 to 11'));
      } else {
        setClassStudentError('');
      }
    }
  };

  const cityHandler = e => {
    const value = e.target.value;
    setCityDirty(true);

    if (value === undefined || value.trim() === '') {
      setCityError(t(''));
    } else if (
      !/^(?!.*['`]{2})(?!.*['`].*['`])(?!.*[-`]{2})(?!.*[-`].*[-`])(?!.*[ `]{2})(?!.*[ `].*[ `])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ'\s-]*)$/.test(
        value.trim(),
      )
    ) {
      setCityError(t('The name of the city must consist only of letters and begin with a capital letter'));
    } else {
      setCityError('');
    }
  };

  const blurHandler = e => {
    const condition = e.target.value === undefined || e.target.value.trim() === '';

    switch (e.target.name) {
      case 'lastName':
        setLastNameDirty(true);
        if (condition) {
          setLastNameError(t('field is required'));
        } else {
          setLastNameError('');
        }
        break;

      case 'firstName':
        setFirstNameDirty(true);
        if (condition) {
          setFirstNameError(t('field is required'));
        } else {
          setFirstNameError('');
        }
        break;

      case 'email':
        setEmailDirty(true);
        if (condition) {
          setLastNameError(t('field is required'));
        } else {
          setLastNameError('');
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (
      lastNameError ||
      firstNameError ||
      patronymicError ||
      emailError ||
      classStudentError ||
      ageError ||
      cityError
    ) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  }, [lastNameError, firstNameError, patronymicError, emailError, classStudentError, ageError, cityError]);

  const nameInitials = (lastName, firstName, patronymic) => {
    let initials = `${lastName.charAt(0).toUpperCase()}${lastName.slice(1)} ${firstName.charAt(0).toUpperCase()}.`;

    if (patronymic) {
      initials += ` ${patronymic.charAt(0).toUpperCase()}.`;
    }

    return initials;
  };

  const onSubmitFunc = async () => {
    let profileAddress;
    try {
      profileAddress = await assertProfileAvailable(email, 'Students', student?.email?.replace(/\./g, ''),
        path => get(ref(database, path)));
    } catch (error) {
      setEmailError(error.message || 'Не вдалося перевірити профілі. Спробуйте ще раз.');
      return;
    }
    const id = profileAddress.key;
    const initials = nameInitials(lastName, firstName, patronymic);
    const oldEmail = student.email;
    console.log('oldEmail: ', oldEmail);
    const FIO = student.FIO;
    const newEmail = profileAddress.email;
    console.log('newEmail: ', newEmail);
    const oldId = oldEmail.replace(/\./g, '');
    console.log('oldId: ', oldId);
    const newId = newEmail.replace(/\./g, '');
    console.log('newId: ', newId);

    if (oldId !== newId) {
      const oldRefStudent = ref(database, `Students/${oldId}`);
      const newRefStudent = ref(database, `Students/${newId}`);
      const oldRefNotebooks = ref(database, `Notebooks/${oldId}`);
      const newRefNotebooks = ref(database, `Notebooks/${newId}`);
      const oldFsNotebooks = doc(firestore, 'notebook-content/', oldId);
      const newFsNotebooks = doc(firestore, 'notebook-content/', newId);

      try {
        const snapshot = await get(oldRefStudent);
        const snapshotNotebooks = await get(oldRefNotebooks);
        const snapshotFsNotebooks = await getDoc(oldFsNotebooks);

        if (snapshot.exists()) {
          await set(newRefStudent, snapshot.val());
          if (oldRefStudent) {
            await remove(oldRefStudent);
            setTimeout(async () => {
              await set(newRefNotebooks, snapshotNotebooks.val());
            }, 0);
          }

          if (!oldRefNotebooks) {
            await remove(oldRefNotebooks);
            await setDoc(newFsNotebooks, snapshotFsNotebooks.data());
            await deleteDoc(oldFsNotebooks);
          }

          navigate(`/studentView/${newId}`, { state: { fio: FIO } });
          location.reload();
        } else {
          throw new Error(`Record with id ${id} does not exist`);
        }
      } catch (error) {
        console.log(error);
        throwErrorRollbar(error);
        return;
      }
    }

    // TODO: for added new subjects
    // let subjects = {};

    // if (student.subjects) {
    //   subjects = { ...student.subjects };
    // }

    // subjects['kvol'] = {
    //   activeSub: false,
    //   name: 'kvol',
    //   getNotebook: false,
    // };

    try {
      await update(ref(database, `Students/${id}`), {
        FIO: initials,
        lastName: lastName,
        firstName: firstName,
        patronymic: patronymic,
        age: age,
        classStudent: classStudent,
        city: city,
        email: profileAddress.email,
        branch: branch,
        // TODO: for added new subjects
        // subjects: subjects,
      });

      fetchStudentView();
      setOpen(false);
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  return (
    <div
      className={open ? 'modal-form modal-form--open' : 'modal-form'}
      onMouseDown={e => {
        setOpen(false);
        e.stopPropagation();
      }}
    >
      <div
        className="modal-form-content"
        onMouseDown={e => {
          e.stopPropagation();
        }}
      >
        <form>
          <div className="modal-header">
            <h2>{t('updateStudent')}:</h2>
            <button
              className="btn btn-icon"
              onClick={e => {
                setOpen(false);
                e.preventDefault();
              }}
            >
              <span className="icon icon-plus"></span>
            </button>
          </div>

          <div className="modal-body" id="modal-body">
            <div className="form-control autocomplete-control">
              <Autocomplete
                id="lastName"
                options={[]}
                value={student ? student.lastName : ''}
                onInputChange={(e, v) => setLastName(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('lastName')}
                    value={student.lastName}
                    onChange={lastNameHandler}
                    name="lastName"
                    placeholder=" "
                  />
                )}
              />
              {lastNameDirty && lastNameError && <span className="error">{lastNameError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="firstName"
                options={[]}
                value={student ? student.firstName : ''}
                onInputChange={(e, v) => setFirstName(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('firstName')}
                    value={student.firstName}
                    onChange={firstNameHandler}
                    name="firstName"
                    placeholder=" "
                  />
                )}
              />
              {firstNameDirty && firstNameError && <span className="error">{firstNameError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="patronymic"
                options={[]}
                value={student ? student.patronymic : ''}
                onInputChange={(e, v) => setPatronymic(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('patronymic')}
                    value={student.patronymic}
                    onChange={patronymicHandler}
                    placeholder=" "
                  />
                )}
              />
              {patronymicDirty && patronymicError && <span className="error">{patronymicError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="email"
                options={[]}
                value={student ? student.email : ''}
                onInputChange={(e, v) => setEmail(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('email')}
                    value={student.email}
                    onChange={emailHandler}
                    name="email"
                    placeholder=" "
                  />
                )}
              />
              {emailDirty && emailError && <span className="error">{emailError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="age"
                options={[]}
                value={student ? student.age : ''}
                onInputChange={(e, v) => setAge(v)}
                freeSolo
                renderInput={params => (
                  <TextField {...params} label={t('age')} value={student.age} onChange={ageHandler} placeholder=" " />
                )}
              />
              {ageDirty && ageError && <span className="error">{ageError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="classStudent"
                options={[]}
                value={student ? student.classStudent : ''}
                onInputChange={(e, v) => setClassStudent(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('class')}
                    value={student.classStudent}
                    onChange={classStudentHandler}
                    placeholder=" "
                  />
                )}
              />
              {classStudentDirty && classStudentError && <span className="error">{classStudentError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="city"
                options={[]}
                value={student ? student.city : ''}
                onInputChange={(e, v) => setCity(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('city')}
                    value={student.city}
                    onChange={cityHandler}
                    name="city"
                    placeholder=" "
                  />
                )}
              />
              {cityDirty && cityError && <span className="error">{cityError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="branch"
                options={departmentsArr}
                value={branch}
                onInputChange={(e, v) => setBranch(v)}
                renderInput={params => (
                  <TextField {...params} label={t('branch')} value={student.branch} placeholder=" " />
                )}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-primary more btn-active"
              onClick={e => {
                onSubmitFunc();
                e.preventDefault();
              }}
              disabled={!isFormValid}
            >
              {submit}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStudentModal;
